import * as React from 'react';

const SvgCreateFlow2 = (props) => (
  <svg
    width={488}
    height={741}
    viewBox="0 0 488 741"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_724_104577"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={488}
      height={741}
    >
      <path
        d="M0 0H476C482.627 0 488 5.37258 488 12V729C488 735.627 482.627 741 476 741H0V0Z"
        fill="#4E53BC"
      />
    </mask>
    <g mask="url(#mask0_724_104577)">
      <path
        d="M193.313 118.817H128.987V183.143H193.313V118.817Z"
        stroke="url(#paint0_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.313 183.143H128.987V247.469H193.313V183.143Z"
        stroke="url(#paint1_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M257.62 118.817H193.294V183.143H257.62V118.817Z"
        stroke="url(#paint2_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M257.62 183.143H193.294V247.469H257.62V183.143Z"
        stroke="url(#paint3_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M386.275 247.468H257.623V376.12H386.275V247.468Z"
        stroke="url(#paint4_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M450.548 247.468H386.222V311.794H450.548V247.468Z"
        stroke="url(#paint5_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M450.548 311.795H386.222V376.121H450.548V311.795Z"
        stroke="url(#paint6_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M514.873 247.468H450.547V311.794H514.873V247.468Z"
        stroke="url(#paint7_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M514.873 311.795H450.547V376.121H514.873V311.795Z"
        stroke="url(#paint8_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M321.93 633.106H257.604V697.432H321.93V633.106Z"
        stroke="url(#paint9_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M321.93 697.433H257.604V761.759H321.93V697.433Z"
        stroke="url(#paint10_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M386.256 633.106H321.93V697.432H386.256V633.106Z"
        stroke="url(#paint11_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M386.256 697.433H321.93V761.759H386.256V697.433Z"
        stroke="url(#paint12_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M386.258 118.817H257.641V247.434H514.892V118.817H386.275H386.258ZM360.538 147.754H411.978V157.406H360.538V147.754ZM283.361 147.754H334.801V157.406H283.361V147.754ZM283.361 179.909H302.646V189.56H283.361V179.909ZM383.041 221.714H283.361V212.063H383.041V221.714ZM389.475 189.56H321.949V179.909H389.475V189.56ZM424.846 221.714H405.561V212.063H424.846V221.714ZM489.155 221.714H437.715V212.063H489.155V221.714ZM489.155 189.56H408.76V179.909H489.155V189.56ZM489.155 157.406H437.715V147.754H489.155V157.406Z"
        stroke="url(#paint13_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M334.798 147.754H283.358V157.405H334.798V147.754Z"
        stroke="url(#paint14_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M302.643 179.907H283.358V189.559H302.643V179.907Z"
        stroke="url(#paint15_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M383.038 212.062H283.358V221.713H383.038V212.062Z"
        stroke="url(#paint16_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M411.96 147.754H360.52V157.405H411.96V147.754Z"
        stroke="url(#paint17_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M389.474 179.907H321.948V189.559H389.474V179.907Z"
        stroke="url(#paint18_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M424.825 212.062H405.54V221.713H424.825V212.062Z"
        stroke="url(#paint19_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M489.135 147.754H437.695V157.405H489.135V147.754Z"
        stroke="url(#paint20_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M489.154 179.907H408.759V189.559H489.154V179.907Z"
        stroke="url(#paint21_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M489.135 212.062H437.695V221.713H489.135V212.062Z"
        stroke="url(#paint22_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.294 273.136C207.488 273.136 219.031 261.593 219.031 247.398H167.574C167.574 261.593 179.117 273.136 193.311 273.136H193.294Z"
        stroke="url(#paint23_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M248.802 247.398H231.885V247.964C231.567 268.982 214.385 285.987 193.297 285.987C172.208 285.987 154.708 268.681 154.708 247.398H137.792C137.792 277.997 162.698 302.904 193.297 302.904C223.895 302.904 248.802 277.997 248.802 247.398Z"
        stroke="url(#paint24_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M257.62 358.25C238.706 369.28 216.733 375.591 193.294 375.591C169.854 375.591 147.882 369.263 128.968 358.25V376.051H257.62V358.25Z"
        stroke="url(#paint25_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M257.62 342.747V321.712C240.367 336.667 217.865 345.735 193.294 345.735C168.723 345.735 146.22 336.667 128.968 321.712V342.747C147.334 355.192 169.483 362.457 193.294 362.457C217.105 362.457 239.254 355.192 257.62 342.747Z"
        stroke="url(#paint26_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.294 315.86C163.774 315.86 138.567 297.087 128.968 270.837V303.327C144.612 321.304 167.645 332.67 193.294 332.67C218.943 332.67 241.976 321.287 257.62 303.327V270.837C248.022 297.069 222.814 315.86 193.294 315.86Z"
        stroke="url(#paint27_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.296 285.987C214.579 285.987 231.885 268.681 231.885 247.398H219.016C219.016 261.593 207.473 273.136 193.278 273.136C179.084 273.136 167.541 261.593 167.541 247.398H154.672C154.672 268.681 171.978 285.987 193.261 285.987H193.296Z"
        stroke="url(#paint28_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.294 315.861C222.814 315.861 248.022 297.088 257.62 270.838V247.398H248.799C248.799 277.997 223.893 302.904 193.294 302.904C162.695 302.904 137.789 278.015 137.789 247.398H128.968V270.838C138.567 297.07 163.774 315.861 193.294 315.861Z"
        stroke="url(#paint29_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M257.62 321.712V303.328C241.976 321.305 218.943 332.672 193.294 332.672C167.645 332.672 144.612 321.288 128.968 303.328V321.712C146.22 336.667 168.723 345.735 193.294 345.735C217.865 345.735 240.367 336.667 257.62 321.712Z"
        stroke="url(#paint30_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M311.719 321.281L348.845 284.155M312.17 322.441L321.463 346.335C322.281 348.44 322.691 349.493 323.281 349.8C323.792 350.066 324.401 350.067 324.912 349.801C325.503 349.494 325.913 348.442 326.734 346.338L350.036 286.627C350.777 284.728 351.148 283.778 350.945 283.172C350.769 282.645 350.355 282.231 349.828 282.055C349.222 281.852 348.272 282.223 346.373 282.964L286.662 306.266C284.558 307.087 283.506 307.497 283.199 308.088C282.933 308.599 282.934 309.208 283.2 309.719C283.507 310.309 284.56 310.719 286.665 311.537L310.559 320.83C310.987 320.996 311.2 321.079 311.38 321.207C311.54 321.321 311.679 321.46 311.793 321.62C311.921 321.8 312.004 322.013 312.17 322.441Z"
        stroke="#60A5DA"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M257.62 358.25V342.747C239.254 355.192 217.105 362.457 193.294 362.457C169.483 362.457 147.334 355.192 128.968 342.747V358.25C147.882 369.28 169.855 375.591 193.294 375.591C216.734 375.591 238.706 369.262 257.62 358.25Z"
        stroke="url(#paint31_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M257.623 504.719H386.222V376.12H257.623V504.719ZM321.931 491.868C293.524 491.868 270.491 468.835 270.491 440.428C270.491 412.022 293.524 388.989 321.931 388.989C350.338 388.989 373.371 412.022 373.371 440.428C373.371 468.835 350.338 491.868 321.931 491.868Z"
        stroke="url(#paint32_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M321.933 388.972C293.526 388.972 270.493 412.005 270.493 440.411C270.493 468.818 293.526 491.851 321.933 491.851C350.34 491.851 373.373 468.818 373.373 440.411C373.373 412.005 350.34 388.972 321.933 388.972ZM309.082 479C298.423 479 289.797 470.356 289.797 459.714C289.797 449.073 298.44 440.429 309.082 440.429C319.723 440.429 328.367 449.073 328.367 459.714C328.367 470.356 319.723 479 309.082 479Z"
        stroke="url(#paint33_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M309.06 478.981C319.711 478.981 328.346 470.347 328.346 459.696C328.346 449.045 319.711 440.41 309.06 440.41C298.409 440.41 289.775 449.045 289.775 459.696C289.775 470.347 298.409 478.981 309.06 478.981Z"
        stroke="url(#paint34_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M386.221 376.104V504.703H514.82V376.104H386.221ZM411.941 395.389H463.381V408.24H411.941V395.389ZM411.941 446.829H424.792V459.68H411.941V446.829ZM489.101 485.417H411.941V472.566H489.101V485.417ZM489.101 459.697H437.661V446.846H489.101V459.697ZM489.101 433.977H411.941V421.126H489.101V433.977ZM489.101 408.258H476.25V395.407H489.101V408.258Z"
        stroke="url(#paint35_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M128.987 -10.0117V118.587H257.586V-10.0117H128.987ZM154.706 9.27372H206.146V22.1248H154.706V9.27372ZM154.706 60.7133H167.575V73.5644H154.706V60.7133ZM231.866 99.3019H154.706V86.4508H231.866V99.3019ZM231.866 73.5821H180.426V60.731H231.866V73.5821ZM231.866 47.8622H154.706V35.0112H231.866V47.8622ZM231.866 22.1425H219.015V9.29142H231.866V22.1425Z"
        stroke="url(#paint36_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M318.287 581.968H304.057L359.138 633.213H373.368L318.287 581.968Z"
        stroke="url(#paint37_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M347.577 581.968H333.365L388.446 633.213H402.658L347.577 581.968Z"
        stroke="url(#paint38_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M376.869 581.968H362.657L417.738 633.213H431.95L376.869 581.968Z"
        stroke="url(#paint39_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M344.078 633.213L288.997 581.968H274.767L329.848 633.213H344.078Z"
        stroke="url(#paint40_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M421.236 581.968L476.317 633.213H490.547L435.466 581.968H421.236Z"
        stroke="url(#paint41_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M450.529 581.968L505.61 633.213H514.802V628.546L464.759 581.968H450.529Z"
        stroke="url(#paint42_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M314.789 633.213L259.708 581.968H257.623V593.263L300.56 633.213H314.789Z"
        stroke="url(#paint43_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M285.499 633.212L257.623 607.28V620.52L271.269 633.212H285.499Z"
        stroke="url(#paint44_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M479.821 581.968L514.804 614.528V601.289L494.051 581.968H479.821Z"
        stroke="url(#paint45_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M406.162 581.968H391.95L447.031 633.213H461.261L406.162 581.968Z"
        stroke="url(#paint46_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M514.803 504.72H257.623V581.879H514.803V504.72ZM299.411 543.291C299.411 537.97 303.724 533.639 309.062 533.639C314.401 533.639 318.714 537.952 318.714 543.291C318.714 548.629 314.401 552.942 309.062 552.942C303.724 552.942 299.411 548.629 299.411 543.291ZM350.85 543.291C350.85 537.97 355.163 533.639 360.502 533.639C365.84 533.639 370.153 537.952 370.153 543.291C370.153 548.629 365.84 552.942 360.502 552.942C355.163 552.942 350.85 548.629 350.85 543.291ZM402.29 543.291C402.29 537.97 406.603 533.639 411.941 533.639C417.28 533.639 421.593 537.952 421.593 543.291C421.593 548.629 417.28 552.942 411.941 552.942C406.603 552.942 402.29 548.629 402.29 543.291ZM453.729 543.291C453.729 537.97 458.043 533.639 463.381 533.639C468.719 533.639 473.033 537.952 473.033 543.291C473.033 548.629 468.719 552.942 463.381 552.942C458.043 552.942 453.729 548.629 453.729 543.291Z"
        stroke="url(#paint47_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M463.381 552.942C468.711 552.942 473.033 548.621 473.033 543.29C473.033 537.96 468.711 533.639 463.381 533.639C458.051 533.639 453.729 537.96 453.729 543.29C453.729 548.621 458.051 552.942 463.381 552.942Z"
        stroke="url(#paint48_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M411.941 552.942C417.272 552.942 421.593 548.621 421.593 543.29C421.593 537.96 417.272 533.639 411.941 533.639C406.611 533.639 402.29 537.96 402.29 543.29C402.29 548.621 406.611 552.942 411.941 552.942Z"
        stroke="url(#paint49_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M360.502 552.942C365.832 552.942 370.153 548.621 370.153 543.29C370.153 537.96 365.832 533.639 360.502 533.639C355.171 533.639 350.85 537.96 350.85 543.29C350.85 548.621 355.171 552.942 360.502 552.942Z"
        stroke="url(#paint50_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M309.062 552.942C314.393 552.942 318.714 548.621 318.714 543.29C318.714 537.96 314.393 533.639 309.062 533.639C303.732 533.639 299.411 537.96 299.411 543.29C299.411 548.621 303.732 552.942 309.062 552.942Z"
        stroke="url(#paint51_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M461.346 633.301H476.406L421.131 581.861H406.07L461.346 633.301Z"
        stroke="url(#paint52_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M402.767 633.301H417.828L362.552 581.861H347.491L402.767 633.301Z"
        stroke="url(#paint53_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M432.056 633.301H447.117L391.841 581.861H376.781L432.056 633.301Z"
        stroke="url(#paint54_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M479.713 581.861H464.652L514.819 628.546V614.528L479.713 581.861Z"
        stroke="url(#paint55_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M490.638 633.301H505.699L450.423 581.861H435.363L490.638 633.301Z"
        stroke="url(#paint56_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M257.623 620.521V633.301H271.375L257.623 620.521Z"
        stroke="url(#paint57_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M285.605 633.301H300.666L257.623 593.263V607.28L285.605 633.301Z"
        stroke="url(#paint58_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M373.474 633.301H388.535L333.259 581.861H318.199L373.474 633.301Z"
        stroke="url(#paint59_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M314.895 633.301H329.956L274.681 581.861H259.62L314.895 633.301Z"
        stroke="url(#paint60_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M344.185 633.301H359.246L303.97 581.861H288.909L344.185 633.301Z"
        stroke="url(#paint61_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.135 697.433C157.658 697.433 128.915 668.69 128.915 633.213V761.653H257.355V633.213C257.355 668.673 228.595 697.433 193.135 697.433ZM161.016 742.385H148.165V729.534H161.016V742.385ZM186.701 742.385H173.85V729.534H186.701V742.385ZM212.385 742.385H199.534V729.534H212.385V742.385ZM238.07 742.385H225.219V729.534H238.07V742.385Z"
        stroke="url(#paint62_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M128.915 504.772V633.212C128.915 597.735 157.675 568.992 193.135 568.992C228.595 568.992 257.355 597.753 257.355 633.212V504.772H128.915ZM154.599 538.482C151.046 538.482 148.183 535.601 148.183 532.065C148.183 528.53 151.064 525.649 154.599 525.649C158.135 525.649 161.016 528.53 161.016 532.065C161.016 535.601 158.135 538.482 154.599 538.482ZM180.284 538.482C176.731 538.482 173.867 535.601 173.867 532.065C173.867 528.53 176.749 525.649 180.284 525.649C183.819 525.649 186.701 528.53 186.701 532.065C186.701 535.601 183.819 538.482 180.284 538.482ZM205.968 538.482C202.415 538.482 199.552 535.601 199.552 532.065C199.552 528.53 202.433 525.649 205.968 525.649C209.504 525.649 212.385 528.53 212.385 532.065C212.385 535.601 209.504 538.482 205.968 538.482ZM231.653 538.482C228.1 538.482 225.236 535.601 225.236 532.065C225.236 528.53 228.117 525.649 231.653 525.649C235.188 525.649 238.07 528.53 238.07 532.065C238.07 535.601 235.188 538.482 231.653 538.482Z"
        stroke="url(#paint63_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.135 568.993C157.658 568.993 128.915 597.753 128.915 633.213C128.915 668.673 157.676 697.433 193.135 697.433C228.595 697.433 257.355 668.673 257.355 633.213C257.355 597.753 228.595 568.993 193.135 568.993ZM193.135 668.531C173.62 668.531 157.817 652.711 157.817 633.213C157.817 613.716 173.638 597.895 193.135 597.895C212.633 597.895 228.454 613.716 228.454 633.213C228.454 652.711 212.633 668.531 193.135 668.531Z"
        stroke="url(#paint64_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.138 597.895C173.623 597.895 157.82 613.715 157.82 633.213C157.82 652.71 173.641 668.531 193.138 668.531C212.636 668.531 228.457 652.71 228.457 633.213C228.457 613.715 212.636 597.895 193.138 597.895ZM193.138 649.281C184.265 649.281 177.088 642.087 177.088 633.231C177.088 624.374 184.282 617.18 193.138 617.18C201.994 617.18 209.189 624.374 209.189 633.231C209.189 642.087 201.994 649.281 193.138 649.281Z"
        stroke="url(#paint65_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M193.133 649.263C201.998 649.263 209.184 642.077 209.184 633.213C209.184 624.348 201.998 617.162 193.133 617.162C184.269 617.162 177.083 624.348 177.083 633.213C177.083 642.077 184.269 649.263 193.133 649.263Z"
        stroke="url(#paint66_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M154.601 538.483C158.145 538.483 161.017 535.61 161.017 532.066C161.017 528.522 158.145 525.649 154.601 525.649C151.057 525.649 148.184 528.522 148.184 532.066C148.184 535.61 151.057 538.483 154.601 538.483Z"
        stroke="url(#paint67_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M180.286 538.483C183.83 538.483 186.703 535.61 186.703 532.066C186.703 528.522 183.83 525.649 180.286 525.649C176.742 525.649 173.87 528.522 173.87 532.066C173.87 535.61 176.742 538.483 180.286 538.483Z"
        stroke="url(#paint68_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M205.987 538.483C209.531 538.483 212.404 535.61 212.404 532.066C212.404 528.522 209.531 525.649 205.987 525.649C202.444 525.649 199.571 528.522 199.571 532.066C199.571 535.61 202.444 538.483 205.987 538.483Z"
        stroke="url(#paint69_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M231.67 538.483C235.214 538.483 238.087 535.61 238.087 532.066C238.087 528.522 235.214 525.649 231.67 525.649C228.126 525.649 225.253 528.522 225.253 532.066C225.253 535.61 228.126 538.483 231.67 538.483Z"
        stroke="url(#paint70_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M161.035 729.551H148.184V742.402H161.035V729.551Z"
        stroke="url(#paint71_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M186.721 729.551H173.87V742.402H186.721V729.551Z"
        stroke="url(#paint72_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M212.403 729.551H199.552V742.402H212.403V729.551Z"
        stroke="url(#paint73_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M238.089 729.551H225.238V742.402H238.089V729.551Z"
        stroke="url(#paint74_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M128.987 376.104V504.703H257.586V376.104H128.987ZM231.866 453.263H206.146V478.983H180.426V453.263H154.706V427.543H180.426V401.823H206.146V427.543H231.866V453.263Z"
        stroke="url(#paint75_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M231.866 427.561H206.146V401.823H180.426V427.561H154.706V453.281H180.426V479H206.146V453.281H231.866V427.561Z"
        stroke="url(#paint76_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M25.7878 324.61H26.0171H25.7878Z"
        stroke="url(#paint77_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M103.233 298.873H128.74V273.136H103.021V247.398H0.0353536L0 298.891H26.0026V273.136H51.528V298.767H77.2655V298.873V324.611H103.233V298.873Z"
        stroke="url(#paint78_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M51.7394 324.628H26.002V350.365H51.7394V324.628Z"
        stroke="url(#paint79_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M26.0043 298.891H0.266846V324.628H26.0043V298.891Z"
        stroke="url(#paint80_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M103.232 324.628H77.4941V350.365H103.232V324.628Z"
        stroke="url(#paint81_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M77.4965 324.628H51.759V350.365H77.4965V324.628Z"
        stroke="url(#paint82_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M51.7394 298.891H26.002V324.628H51.7394V298.891Z"
        stroke="url(#paint83_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M128.97 247.398H103.233V273.136H128.97V247.398Z"
        stroke="url(#paint84_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M51.7394 273.135H26.002V298.872H51.7394V273.135Z"
        stroke="url(#paint85_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M77.4965 298.891H51.759V324.628H77.4965V298.891Z"
        stroke="url(#paint86_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M77.4965 350.366H51.759V376.104H77.4965V350.366Z"
        stroke="url(#paint87_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M128.97 298.873H103.233V324.611H128.97V298.873Z"
        stroke="url(#paint88_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M103.232 324.61V350.366H77.4941V376.103H103.232H128.987V324.61H103.232Z"
        stroke="url(#paint89_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M25.792 350.366V324.293H0.266602V376.104H25.792H51.7592V350.366H25.792Z"
        stroke="url(#paint90_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M29.8914 399.472H98.8487C102.419 399.472 105.318 402.371 105.318 405.941V474.899C105.318 478.469 102.419 481.368 98.8487 481.368H29.8914C26.3206 481.368 23.4216 478.469 23.4216 474.899V405.941C23.4216 402.371 26.3206 399.472 29.8914 399.472Z"
        stroke="url(#paint91_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M85.9258 461.96V446.156C85.9258 438.414 84.2642 432.475 75.2137 432.475C70.8652 432.475 67.9485 434.861 66.7641 437.124H66.6404V433.199H58.0671V461.977H66.9939V447.73C66.9939 443.965 67.701 440.341 72.3854 440.341C77.0697 440.341 77.0344 444.654 77.0344 447.96V461.96H85.9258Z"
        stroke="url(#paint92_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M52.4639 433.182H43.5371V461.959H52.4639V433.182Z"
        stroke="url(#paint93_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M47.992 418.862C45.1284 418.862 42.7773 421.16 42.7773 424.042C42.7773 426.905 45.0753 429.256 47.9567 429.256C50.8203 429.256 53.1713 426.958 53.1713 424.077V424.024C53.1713 421.16 50.8557 418.845 47.992 418.845V418.862Z"
        stroke="url(#paint94_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M128.866 376.104H0.266846V504.703H128.866V376.104Z"
        stroke="url(#paint95_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M514.96 633.143H386.361V761.742H514.96V633.143Z"
        stroke="url(#paint96_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M0.266602 504.72V633.301H128.866V504.72H0.266602ZM38.8375 607.599C31.7314 607.599 25.9687 601.836 25.9687 594.748C25.9687 587.659 31.7314 581.879 38.8375 581.879C45.9436 581.879 51.6885 587.642 51.6885 594.748C51.6885 601.854 45.9259 607.599 38.8375 607.599ZM38.8375 556.159C31.7314 556.159 25.9687 550.397 25.9687 543.308C25.9687 536.22 31.7314 530.457 38.8375 530.457C45.9436 530.457 51.6885 536.22 51.6885 543.308C51.6885 550.397 45.9259 556.159 38.8375 556.159ZM90.2771 607.599C83.171 607.599 77.4083 601.836 77.4083 594.748C77.4083 587.659 83.171 581.879 90.2771 581.879C97.3832 581.879 103.128 587.642 103.128 594.748C103.128 601.854 97.3655 607.599 90.2771 607.599ZM90.2771 556.159C83.171 556.159 77.4083 550.397 77.4083 543.308C77.4083 536.22 83.171 530.457 90.2771 530.457C97.3832 530.457 103.128 536.22 103.128 543.308C103.128 550.397 97.3655 556.159 90.2771 556.159Z"
        stroke="url(#paint97_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M38.8374 530.439C45.9435 530.439 51.7061 536.202 51.7061 543.291C51.7061 550.379 45.9435 556.142 38.8374 556.142C31.7313 556.142 25.9863 550.379 25.9863 543.291C25.9863 536.202 31.749 530.439 38.8374 530.439Z"
        stroke="url(#paint98_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M90.273 530.439C97.3791 530.439 103.142 536.202 103.142 543.291C103.142 550.379 97.3791 556.142 90.273 556.142C83.1669 556.142 77.4043 550.379 77.4043 543.291C77.4043 536.202 83.1669 530.439 90.273 530.439Z"
        stroke="url(#paint99_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M38.8374 581.861C45.9435 581.861 51.7061 587.624 51.7061 594.73C51.7061 601.836 45.9435 607.581 38.8374 607.581C31.7313 607.581 25.9863 601.818 25.9863 594.73C25.9863 587.642 31.749 581.861 38.8374 581.861Z"
        stroke="url(#paint100_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M90.273 581.861C97.3791 581.861 103.142 587.624 103.142 594.73C103.142 601.836 97.3791 607.581 90.273 607.581C83.1669 607.581 77.4043 601.818 77.4043 594.73C77.4043 587.642 83.1669 581.861 90.273 581.861Z"
        stroke="url(#paint101_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M64.5926 697.627L128.919 761.953V697.627H0.266602L64.5926 633.301L128.919 697.627V633.301H0.266602V761.953L64.5926 697.627Z"
        stroke="url(#paint102_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.919 761.954L64.5929 697.628L0.266846 761.954H128.919Z"
        stroke="url(#paint103_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.919 697.627L64.5926 633.301L0.266602 697.627H128.919Z"
        stroke="url(#paint104_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M322.107 -10.0293H257.781V54.2968H322.107V-10.0293Z"
        stroke="url(#paint105_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M322.107 54.2959H257.781V118.622H322.107V54.2959Z"
        stroke="url(#paint106_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M386.433 -10.0293H322.107V54.2968H386.433V-10.0293Z"
        stroke="url(#paint107_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M386.433 54.2959H322.107V118.622H386.433V54.2959Z"
        stroke="url(#paint108_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M515.137 -10.0117H386.538V118.587H515.137V-10.0117Z"
        stroke="url(#paint109_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeMiterlimit={10}
      />
      <path
        d="M64.7665 54.491L129.092 118.817V54.491H0.44043L64.7665 -9.83496L129.092 54.491V-9.83496H0.44043V118.817L64.7665 54.491Z"
        stroke="url(#paint110_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M129.092 118.816L64.7665 54.4902L0.44043 118.816H129.092Z"
        stroke="url(#paint111_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M129.092 54.491L64.7665 -9.83496L0.44043 54.491H129.092Z"
        stroke="url(#paint112_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={1.32576}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.3944 196.747L99.4069 171.086L73.7331 171.086L73.7456 145.425L48.0718 145.425L48.0718 171.099L22.4105 171.086L22.4105 196.76L48.0718 196.747L48.0718 222.421L73.7331 222.409L73.7331 196.76L99.3944 196.747Z"
        stroke="url(#paint113_linear_724_104577)"
        strokeOpacity={0.37}
        strokeWidth={2.33}
        strokeMiterlimit={10}
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_724_104577"
        x1={161.15}
        y1={118.817}
        x2={161.15}
        y2={183.143}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_724_104577"
        x1={161.15}
        y1={183.143}
        x2={161.15}
        y2={247.469}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_724_104577"
        x1={225.457}
        y1={118.817}
        x2={225.457}
        y2={183.143}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_724_104577"
        x1={225.457}
        y1={183.143}
        x2={225.457}
        y2={247.469}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_724_104577"
        x1={321.949}
        y1={247.468}
        x2={321.949}
        y2={376.12}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_724_104577"
        x1={418.385}
        y1={247.468}
        x2={418.385}
        y2={311.794}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_724_104577"
        x1={418.385}
        y1={311.795}
        x2={418.385}
        y2={376.121}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_724_104577"
        x1={482.71}
        y1={247.468}
        x2={482.71}
        y2={311.794}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_724_104577"
        x1={482.71}
        y1={311.795}
        x2={482.71}
        y2={376.121}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_724_104577"
        x1={289.767}
        y1={633.106}
        x2={289.767}
        y2={697.432}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_724_104577"
        x1={289.767}
        y1={697.433}
        x2={289.767}
        y2={761.759}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_724_104577"
        x1={354.093}
        y1={633.106}
        x2={354.093}
        y2={697.432}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_724_104577"
        x1={354.093}
        y1={697.433}
        x2={354.093}
        y2={761.759}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_724_104577"
        x1={386.267}
        y1={118.817}
        x2={386.267}
        y2={247.434}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_724_104577"
        x1={309.078}
        y1={147.754}
        x2={309.078}
        y2={157.405}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_724_104577"
        x1={293.001}
        y1={179.907}
        x2={293.001}
        y2={189.559}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_724_104577"
        x1={333.198}
        y1={212.062}
        x2={333.198}
        y2={221.713}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_724_104577"
        x1={386.24}
        y1={147.754}
        x2={386.24}
        y2={157.405}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_724_104577"
        x1={355.711}
        y1={179.907}
        x2={355.711}
        y2={189.559}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_724_104577"
        x1={415.183}
        y1={212.062}
        x2={415.183}
        y2={221.713}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_724_104577"
        x1={463.415}
        y1={147.754}
        x2={463.415}
        y2={157.405}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_724_104577"
        x1={448.956}
        y1={179.907}
        x2={448.956}
        y2={189.559}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_724_104577"
        x1={463.415}
        y1={212.062}
        x2={463.415}
        y2={221.713}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_724_104577"
        x1={193.303}
        y1={247.398}
        x2={193.303}
        y2={273.136}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_724_104577"
        x1={193.297}
        y1={247.398}
        x2={193.297}
        y2={302.904}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_724_104577"
        x1={193.294}
        y1={358.25}
        x2={193.294}
        y2={376.051}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_724_104577"
        x1={193.294}
        y1={321.712}
        x2={193.294}
        y2={362.457}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_724_104577"
        x1={193.294}
        y1={270.837}
        x2={193.294}
        y2={332.67}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_724_104577"
        x1={193.278}
        y1={247.398}
        x2={193.278}
        y2={285.987}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_724_104577"
        x1={193.294}
        y1={247.398}
        x2={193.294}
        y2={315.861}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_724_104577"
        x1={193.294}
        y1={303.328}
        x2={193.294}
        y2={345.735}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_724_104577"
        x1={193.294}
        y1={342.747}
        x2={193.294}
        y2={375.591}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_724_104577"
        x1={321.922}
        y1={376.12}
        x2={321.922}
        y2={504.719}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_724_104577"
        x1={321.933}
        y1={388.972}
        x2={321.933}
        y2={491.851}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_724_104577"
        x1={309.06}
        y1={440.41}
        x2={309.06}
        y2={478.981}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_724_104577"
        x1={450.521}
        y1={376.104}
        x2={450.521}
        y2={504.703}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_724_104577"
        x1={193.286}
        y1={-10.0117}
        x2={193.286}
        y2={118.587}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_724_104577"
        x1={338.712}
        y1={581.968}
        x2={338.712}
        y2={633.213}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_724_104577"
        x1={368.011}
        y1={581.968}
        x2={368.011}
        y2={633.213}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_724_104577"
        x1={397.304}
        y1={581.968}
        x2={397.304}
        y2={633.213}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_724_104577"
        x1={309.423}
        y1={581.968}
        x2={309.423}
        y2={633.213}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint41_linear_724_104577"
        x1={455.892}
        y1={581.968}
        x2={455.892}
        y2={633.213}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint42_linear_724_104577"
        x1={482.665}
        y1={581.968}
        x2={482.665}
        y2={633.213}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint43_linear_724_104577"
        x1={286.206}
        y1={581.968}
        x2={286.206}
        y2={633.213}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint44_linear_724_104577"
        x1={271.561}
        y1={607.28}
        x2={271.561}
        y2={633.212}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint45_linear_724_104577"
        x1={497.313}
        y1={581.968}
        x2={497.313}
        y2={614.528}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint46_linear_724_104577"
        x1={426.605}
        y1={581.968}
        x2={426.605}
        y2={633.213}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint47_linear_724_104577"
        x1={386.213}
        y1={504.72}
        x2={386.213}
        y2={581.879}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint48_linear_724_104577"
        x1={463.381}
        y1={533.639}
        x2={463.381}
        y2={552.942}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint49_linear_724_104577"
        x1={411.941}
        y1={533.639}
        x2={411.941}
        y2={552.942}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint50_linear_724_104577"
        x1={360.502}
        y1={533.639}
        x2={360.502}
        y2={552.942}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint51_linear_724_104577"
        x1={309.062}
        y1={533.639}
        x2={309.062}
        y2={552.942}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint52_linear_724_104577"
        x1={441.238}
        y1={581.861}
        x2={441.238}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint53_linear_724_104577"
        x1={382.66}
        y1={581.861}
        x2={382.66}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint54_linear_724_104577"
        x1={411.949}
        y1={581.861}
        x2={411.949}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint55_linear_724_104577"
        x1={489.736}
        y1={581.861}
        x2={489.736}
        y2={628.546}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint56_linear_724_104577"
        x1={470.531}
        y1={581.861}
        x2={470.531}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint57_linear_724_104577"
        x1={264.499}
        y1={620.521}
        x2={264.499}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint58_linear_724_104577"
        x1={279.144}
        y1={593.263}
        x2={279.144}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint59_linear_724_104577"
        x1={353.367}
        y1={581.861}
        x2={353.367}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint60_linear_724_104577"
        x1={294.788}
        y1={581.861}
        x2={294.788}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint61_linear_724_104577"
        x1={324.078}
        y1={581.861}
        x2={324.078}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint62_linear_724_104577"
        x1={193.135}
        y1={633.213}
        x2={193.135}
        y2={761.653}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint63_linear_724_104577"
        x1={193.135}
        y1={504.772}
        x2={193.135}
        y2={633.212}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint64_linear_724_104577"
        x1={193.135}
        y1={568.993}
        x2={193.135}
        y2={697.433}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint65_linear_724_104577"
        x1={193.138}
        y1={597.895}
        x2={193.138}
        y2={668.531}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint66_linear_724_104577"
        x1={193.133}
        y1={617.162}
        x2={193.133}
        y2={649.263}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint67_linear_724_104577"
        x1={154.601}
        y1={525.649}
        x2={154.601}
        y2={538.483}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint68_linear_724_104577"
        x1={180.286}
        y1={525.649}
        x2={180.286}
        y2={538.483}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint69_linear_724_104577"
        x1={205.987}
        y1={525.649}
        x2={205.987}
        y2={538.483}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint70_linear_724_104577"
        x1={231.67}
        y1={525.649}
        x2={231.67}
        y2={538.483}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint71_linear_724_104577"
        x1={154.61}
        y1={729.551}
        x2={154.61}
        y2={742.402}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint72_linear_724_104577"
        x1={180.295}
        y1={729.551}
        x2={180.295}
        y2={742.402}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint73_linear_724_104577"
        x1={205.978}
        y1={729.551}
        x2={205.978}
        y2={742.402}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint74_linear_724_104577"
        x1={231.664}
        y1={729.551}
        x2={231.664}
        y2={742.402}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint75_linear_724_104577"
        x1={193.286}
        y1={376.104}
        x2={193.286}
        y2={504.703}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint76_linear_724_104577"
        x1={193.286}
        y1={401.823}
        x2={193.286}
        y2={479}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint77_linear_724_104577"
        x1={25.9025}
        y1={324.61}
        x2={25.9025}
        y2={325.61}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint78_linear_724_104577"
        x1={64.3702}
        y1={247.398}
        x2={64.3702}
        y2={324.611}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint79_linear_724_104577"
        x1={38.8707}
        y1={324.628}
        x2={38.8707}
        y2={350.365}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint80_linear_724_104577"
        x1={13.1356}
        y1={298.891}
        x2={13.1356}
        y2={324.628}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint81_linear_724_104577"
        x1={90.3629}
        y1={324.628}
        x2={90.3629}
        y2={350.365}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint82_linear_724_104577"
        x1={64.6278}
        y1={324.628}
        x2={64.6278}
        y2={350.365}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint83_linear_724_104577"
        x1={38.8707}
        y1={298.891}
        x2={38.8707}
        y2={324.628}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint84_linear_724_104577"
        x1={116.101}
        y1={247.398}
        x2={116.101}
        y2={273.136}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint85_linear_724_104577"
        x1={38.8707}
        y1={273.135}
        x2={38.8707}
        y2={298.872}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint86_linear_724_104577"
        x1={64.6278}
        y1={298.891}
        x2={64.6278}
        y2={324.628}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint87_linear_724_104577"
        x1={64.6278}
        y1={350.366}
        x2={64.6278}
        y2={376.104}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint88_linear_724_104577"
        x1={116.101}
        y1={298.873}
        x2={116.101}
        y2={324.611}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint89_linear_724_104577"
        x1={103.24}
        y1={324.61}
        x2={103.24}
        y2={376.103}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint90_linear_724_104577"
        x1={26.0129}
        y1={324.293}
        x2={26.0129}
        y2={376.104}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint91_linear_724_104577"
        x1={64.37}
        y1={399.472}
        x2={64.37}
        y2={481.368}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint92_linear_724_104577"
        x1={71.9965}
        y1={432.475}
        x2={71.9965}
        y2={461.977}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint93_linear_724_104577"
        x1={48.0005}
        y1={433.182}
        x2={48.0005}
        y2={461.959}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint94_linear_724_104577"
        x1={47.9743}
        y1={418.845}
        x2={47.9743}
        y2={429.256}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint95_linear_724_104577"
        x1={64.5664}
        y1={376.104}
        x2={64.5664}
        y2={504.703}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint96_linear_724_104577"
        x1={450.661}
        y1={633.143}
        x2={450.661}
        y2={761.742}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint97_linear_724_104577"
        x1={64.5661}
        y1={504.72}
        x2={64.5661}
        y2={633.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint98_linear_724_104577"
        x1={38.8462}
        y1={530.439}
        x2={38.8462}
        y2={556.142}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint99_linear_724_104577"
        x1={90.273}
        y1={530.439}
        x2={90.273}
        y2={556.142}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint100_linear_724_104577"
        x1={38.8462}
        y1={581.861}
        x2={38.8462}
        y2={607.581}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint101_linear_724_104577"
        x1={90.273}
        y1={581.861}
        x2={90.273}
        y2={607.581}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint102_linear_724_104577"
        x1={64.5926}
        y1={633.301}
        x2={64.5926}
        y2={761.953}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint103_linear_724_104577"
        x1={64.5929}
        y1={697.628}
        x2={64.5929}
        y2={761.954}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint104_linear_724_104577"
        x1={64.5926}
        y1={633.301}
        x2={64.5926}
        y2={697.627}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint105_linear_724_104577"
        x1={289.944}
        y1={-10.0293}
        x2={289.944}
        y2={54.2968}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint106_linear_724_104577"
        x1={289.944}
        y1={54.2959}
        x2={289.944}
        y2={118.622}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint107_linear_724_104577"
        x1={354.27}
        y1={-10.0293}
        x2={354.27}
        y2={54.2968}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint108_linear_724_104577"
        x1={354.27}
        y1={54.2959}
        x2={354.27}
        y2={118.622}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint109_linear_724_104577"
        x1={450.837}
        y1={-10.0117}
        x2={450.837}
        y2={118.587}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint110_linear_724_104577"
        x1={64.7665}
        y1={-9.83496}
        x2={64.7665}
        y2={118.817}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint111_linear_724_104577"
        x1={64.7665}
        y1={54.4902}
        x2={64.7665}
        y2={118.816}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint112_linear_724_104577"
        x1={64.7665}
        y1={-9.83496}
        x2={64.7665}
        y2={54.491}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
      <linearGradient
        id="paint113_linear_724_104577"
        x1={86.57}
        y1={158.249}
        x2={35.2349}
        y2={209.584}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0520833} stopColor="#00FFBC" />
        <stop offset={1} stopColor="#92CFFF" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgCreateFlow2;
